/**
 * [pug template]
 */
<template lang="pug">
  input(type="number", :id="name", :name="name", v-model="value", :min="minimum", :max="maximum", :disabled="disabled")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'input-number-component',
  props: {
    'name': {
      type: String,
      default: ''
    },
    'disabled': {
      type: Boolean,
      default: false
    },
    'defaultValue': {
      type: [String, Number],
      default: 0
    },
    'min': {
      type: [String, Number],
      default: 0
    },
    'max': {
      type: [String, Number],
      default: 100
    }
  },
  data () {
    return {
      value: null,
      timeout: null
    }
  },
  created: function () {
    this.value = this.defaultValue
  },
  computed: {
    minimum: function () {
      return this.min === 0 && this.max === 0 ? null : this.min
    },
    maximum: function () {
      return this.min === 0 && this.max === 0 ? null : this.max
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (this.defaultValue !== newValue) {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          this.$emit('value-changed', newValue)
        }, 1000)
      }
    },
    defaultValue: function (newValue, oldValue) {
      this.value = newValue
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// InputNumberComponent.vue?40fc597c